import React, { useState } from 'react';

import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightAddon,
  VStack,
} from '../../core-ui';
import { useFormContext } from '../../core-ui/ModalForm';

type FormData = { uid: string; fullName: string; forwardTo: string };

type Props = {
  initialValues: FormData | null;
  onSubmit: (data: FormData) => void;
};

export function SenderAddressForm(props: Props) {
  const { initialValues, onSubmit } = props;
  const [uid, setUid] = useState(initialValues?.uid ?? '');
  const [fullName, setFullName] = useState(initialValues?.fullName ?? '');
  const [forwardTo, setForwardTo] = useState(initialValues?.forwardTo ?? '');
  const formContext = useFormContext();
  formContext.onSubmit(() => onSubmit({ uid, fullName, forwardTo }));
  return (
    <VStack>
      <FormControl>
        <FormLabel>{t('Sender Name')}</FormLabel>
        <Input
          onChange={(event) => setFullName(event.target.value)}
          value={fullName}
        />
      </FormControl>
      <FormControl>
        <FormLabel>{t('Sender Email')}</FormLabel>
        <InputGroup>
          <Input onChange={(event) => setUid(event.target.value)} value={uid} />
          <InputRightAddon children="@mymarket.org" />
        </InputGroup>
      </FormControl>
      <FormControl>
        <FormLabel>{t('Forward Replies to')}</FormLabel>
        <Input
          onChange={(event) => setForwardTo(event.target.value)}
          value={forwardTo}
        />
      </FormControl>
    </VStack>
  );
}
